import { UserX } from 'lucide-react'
import { Link, useParams } from 'react-router'
import useSWR from 'swr'

import { EmptyState } from '@/components/EmptyState'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { ContactDetail } from '@/containers/Contacts/ContactDetail'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { Participant } from '@/interfaces/Participant'

export default function ContactDetailPage() {
  const { id } = useParams()

  const { data: contact, isLoading, error } = useSWR<Participant>(`/api/v2/contacts/${id}`, apiFetcher)

  const title = contact?.name || 'Kontakt'

  useSetPageHeader({
    breadcrumbs: [
      { href: '/contacts', children: 'Kontakty' },
      { href: `/contact/${id}`, children: title },
    ],
    newButton: 'participant',
  })

  return (
    <>
      <title>{title}</title>

      {isLoading && (
        <div className="mx-auto w-full max-w-[1280px] space-y-6">
          <div className="flex items-center gap-4">
            <Skeleton className="size-12 rounded-full" />
            <div className="space-y-2">
              <Skeleton className="h-7 w-64" />
              <Skeleton className="h-4 w-40" />
            </div>
          </div>
          <Skeleton className="h-24 w-full rounded-lg" />
        </div>
      )}

      {!isLoading && !contact && (
        <div className="mx-auto w-full max-w-xl pt-10">
          <EmptyState icon={UserX}
            title="Kontakt jsme nenašli"
            description={error ? 'Možná byl smazán, nebo k němu nemáte přístup.' : undefined}
            ctaButton={
              <Button variant="outline" asChild>
                <Link to="/contacts">Zpět na kontakty</Link>
              </Button>
            }
          />
        </div>
      )}

      {contact && <ContactDetail contact={contact} isLoading={isLoading} />}
    </>
  )
}
